export default __webpack_public_path__ + "static/media/amazon-dark.b023c97e.svg";